import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { StaticPage, TopbarContainer } from '../../containers';
import {
    LayoutSingleColumn,
    LayoutWrapperTopbar,
    LayoutWrapperMain,
    LayoutWrapperFooter,
    Footer,
    IconSpinner,
} from '../../components';
import { adminPageHOC } from '../../util/contextHelpers';

import css from './AdminPanelsPage.css';

const AdminPageHolder = ({
    currentUser,
    history,
    currentUserRequestInProgress,
    children,
    title = 'AdminPage',
    schema = {},
}) => (
    <StaticPage
        title={title}
        schema={schema}
        metaTags={[
            {
                name: 'robots',
                content: 'noindex',
            },
        ]}
    >
        <LayoutSingleColumn>
            <LayoutWrapperTopbar>
                <TopbarContainer />
            </LayoutWrapperTopbar>

            <LayoutWrapperMain className={css.staticPageWrapper}>
                {currentUserRequestInProgress && <IconSpinner />}
                {!currentUserRequestInProgress && (
                    <div className={css.contentWrapper}>
                        {React.Children.map(children, child =>
                            React.cloneElement(child, {
                                currentUser,
                                history,
                                // api,
                            })
                        )}
                    </div>
                )}
            </LayoutWrapperMain>

            <LayoutWrapperFooter>
                <Footer />
            </LayoutWrapperFooter>
        </LayoutSingleColumn>
    </StaticPage>
);

const mapStateToProps = ({ user: { currentUser, currentUserRequestInProgress } }) => ({
    currentUser,
    currentUserRequestInProgress,
});

export default compose(withRouter, connect(mapStateToProps))(adminPageHOC(AdminPageHolder));
